import { DialogTitle, styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';
import { Swiper } from 'swiper/react';

export const sxStyles = {
  dialogTitleButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '&:hover': {
      cursor: 'pointer',
    },
  },
  dialogMain: {
    display: 'flex',
    padding: '4rem',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  dialogContent: {
    display: 'flex',
    maxWidth: '49.75rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2.5rem',
  },
  dialogContentTitles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  greySubtitle: (theme: Theme) => ({
    color: theme.palette.grey['700'],
  }),
  divider: {
    margin: '0 1rem',
    borderRight: `1px solid ${coreThemeColors.grey[300]}`,
  },
  dialogContentPdf: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    alignSelf: 'stretch',
  },
  dialogContentAgreement: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.5rem',
    alignSelf: 'stretch',
  },
  dialogContentDate: {
    marginTop: '2rem',
  },
  footer: (theme: Theme) => ({
    padding: '1.5rem',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
};

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
}));

export const StyledToggle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '40px',

  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.grey[100],
  },
}));

export const StyledList = styled('ul')(() => ({
  margin: 0,
}));

export const StyledPdf = styled(CoreBox, { shouldForwardProp: (prop) => prop !== 'isLoading' })<{
  isLoading: boolean;
}>(({ isLoading, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'center',
  border: isLoading ? 'none' : `1px solid ${theme.palette.grey[300]}`,
  '>': { overflowAnchor: 'none !important' },
}));

export const StyledSwiper = styled(Swiper)(({ theme }) => ({
  width: '100%',

  'swiper-pagination': {
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
  },

  '.swiper-pagination-bullet': {
    background: theme.palette.common.white,
    width: '12px',
    height: '12px',
    border: `1px solid ${theme.palette.primary.dark}`,
    opacity: '1',
  },

  '.swiper-pagination-bullet-active': {
    background: theme.palette.primary.dark,
  },

  '.swiper-slide': {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2rem',

    '& > div:first-of-type': {
      boxSizing: 'border-box',
    },

    [theme.breakpoints.up('sm')]: {
      justifyContent: 'start',
    },
  },
}));
